export default __webpack_public_path__ + "static/media/EnzoMacaroni.feacca8e.png";